import React from "react";
import { Form, Input, Select, Upload, Switch, Image, Checkbox } from "antd";

const { Option } = Select;

const LicenseFormFields = ({
  isEdit,
  countryDetails,
  planOptions,
  fileList,
  onPreview,
  onChange,
  previewImage,
  previewOpen,
  setPreviewOpen,
  setPreviewImage,
  paymentTypes = [],
}) => {
  const UploadButton = (
    <button type="button" className="flex flex-col items-center gap-2">
      <div className="size-7">
        <img src="/assets/icons/upload.svg" alt="icon" />
      </div>
      Upload
    </button>
  );

  return (
    <div className="grid grid-cols-2 gap-4 gap-y-1">
      {!isEdit && (
        <>
          <Form.Item
            label="Name"
            name="name"
            rules={[{ required: true, message: "Please enter name!" }]}
          >
            <Input placeholder="Enter name" size="large" />
          </Form.Item>

          <Form.Item
            label="Email"
            name="email"
            rules={[{ required: true, message: "Please enter email!" }]}
          >
            <Input placeholder="Enter email" size="large" />
          </Form.Item>

          <Form.Item
            label="Password"
            name="password"
            rules={[{ required: true, message: "Please enter password!" }]}
          >
            <Input.Password placeholder="Enter password" size="large" />
          </Form.Item>

          <div className="flex sm:flex-row flex-col sm:gap-4 !m-0">
            <Form.Item
              label={<p className="font-semibold">Country code</p>}
              name="country_code"
              rules={[{ required: true, message: "Please select country" }]}
            >
              <Select placeholder="Country code" size="large">
                {countryDetails.map((countryData, index) => (
                  <Option key={index} value={countryData?.phonecode}>
                    <div className="flex items-center space-x-3">
                      <div className="rounded-full bg-secondaryLight w-9 h-9 flex justify-center items-center">
                        <img
                          src={countryData?.image}
                          alt="flag"
                          className="w-7 h-7 object-contain rounded-full"
                        />
                      </div>
                      <span className="text-base">
                        + {countryData?.phonecode}
                      </span>
                    </div>
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              label={<p className="font-semibold">Mobile No.</p>}
              name="mobile_no"
              rules={[
                { required: true, message: "Please input mobile number!" },
                {
                  pattern: /^\d{10}$/,
                  message: "Please enter valid 10-digit mobile number.",
                },
              ]}
              className="w-full"
            >
              <Input
                size="large"
                type="tel"
                maxLength={10}
                placeholder="Mobile No."
                onKeyPress={(e) => {
                  if (!/[0-9]/.test(e.key)) {
                    e.preventDefault();
                  }
                }}
              />
            </Form.Item>
          </div>

          <Form.Item
            label="Plan"
            name="plan_id"
            rules={[{ required: true, message: "Please select a plan!" }]}
          >
            <Select
              placeholder="Select a plan"
              size="large"
              options={planOptions}
              loading={!planOptions.length}
            />
          </Form.Item>
        </>
      )}

      <Form.Item
        label="Domain Name"
        name="domain_name"
        rules={[{ required: true, message: "Please enter domain name!" }]}
      >
        <Input placeholder={!isEdit ? "Enter domain name" : ""} size="large" />
      </Form.Item>

      <Form.Item
        label="License Name"
        name="license_name"
        rules={[{ required: true, message: "Please enter license name!" }]}
      >
        <Input placeholder={!isEdit ? "Enter license name" : ""} size="large" />
      </Form.Item>

      <Form.Item
        label="Admin Portal URL"
        name="admin_portal_url"
        rules={[{ required: true, message: "Please enter admin portal URL!" }]}
      >
        <Input
          placeholder={!isEdit ? "Enter admin portal URL" : ""}
          size="large"
        />
      </Form.Item>

      <Form.Item
        label="Client Portal URL"
        name="client_portal_url"
        rules={[{ required: true, message: "Please enter client portal URL!" }]}
      >
        <Input
          placeholder={!isEdit ? "Enter client portal URL" : ""}
          size="large"
        />
      </Form.Item>

      <Form.Item label="GST No." name="gst_no">
        <Input placeholder={!isEdit ? "Enter GST No." : ""} size="large" />
      </Form.Item>

      <div className="col-span-2 grid grid-cols-2 gap-4">
        <Form.Item
          label="Payment Types"
          name="payment_types"
          rules={[{ required: true, message: "Please select payment types!" }]}
        >
          <Checkbox.Group className="w-full">
            <div className={`${isEdit ? "grid grid-cols-2" : "grid grid-cols-2 md:grid-cols-4"} gap-2`}>
              {paymentTypes?.map((type) => (
                <Checkbox key={type?.id} value={type?.id}>
                  {type?.name}
                </Checkbox>
              ))}
            </div>
          </Checkbox.Group>
        </Form.Item>

        <div className="grid grid-cols-2 gap-4">
          <Form.Item
            name="is_assign_to_admin"
            label={
              <span className="flex flex-col gap-1">
                <span>Admin Assigns First</span>
                <span className="text-xs text-gray-500 font-normal">
                  Assign files to the Admin for review before allocating them to
                  employees.
                </span>
              </span>
            }
            valuePropName="checked"
          >
            <Switch />
          </Form.Item>

          <Form.Item
            name="task_assign_to_admin"
            label={
              <span className="flex flex-col gap-1">
                <span>Review Before Assignment</span>
                <span className="text-xs text-gray-500 font-normal">
                  Admin reviews each task before it is assigned to employees.
                </span>
              </span>
            }
            valuePropName="checked"
          >
            <Switch />
          </Form.Item>
        </div>

        {previewImage && (
          <Image
            wrapperStyle={{ display: "none" }}
            preview={{
              visible: previewOpen,
              onVisibleChange: (visible) => setPreviewOpen(visible),
              afterOpenChange: (visible) => !visible && setPreviewImage(""),
            }}
            src={previewImage}
          />
        )}
      </div>
      <Form.Item name="logo" label="Business Logo">
        <Upload
          beforeUpload={() => false}
          multiple
          listType="picture-card"
          fileList={fileList}
          onPreview={onPreview}
          onChange={onChange}
        >
          {fileList.length >= 1 ? null : UploadButton}
        </Upload>
      </Form.Item>
    </div>
  );
};

export default LicenseFormFields;
